export default __webpack_public_path__ + "static/media/AdSpace_04.dfd054f4.png";